module.exports = __webpack_public_path__ + "img/7_41.ab000e24.png";